module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/contacts/img_about01-f0ecdd2ed55cd0e6567ae67932aafed2.jpg";